import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import vueDeltaIt from "@deltaww/vue-delta-it"
import "vue-multiselect/dist/vue-multiselect.min.css"
import "bootstrap/dist/css/bootstrap.min.css"
import "font-awesome/css/font-awesome.min.css"
import Swal from "sweetalert2/dist/sweetalert2.all.min.js"
import "@sweetalert2/theme-bulma/bulma.min.css"
import "view-design/dist/styles/iview.css"
// Import Froala Editor
import "froala-editor/js/plugins.pkgd.min.js"
// Import third party plugins
import "froala-editor/js/third_party/embedly.min"
import "froala-editor/js/third_party/font_awesome.min"
import "froala-editor/js/third_party/spell_checker.min"
import "froala-editor/js/third_party/image_tui.min"
// Import Froala Editor css files.
import "froala-editor/css/froala_editor.pkgd.min.css"
import Multiselect from "vue-multiselect"
import VueFroala from "vue-froala-wysiwyg"
Vue.use(VueFroala)
Vue.component("multiselect", Multiselect)
import "@/assets/public.css"
import App from "@/App"
import store from "@/store/index"
import router from "@/config/router"
import i18n from "@/config/lang"
import { menu } from "@/util/menu"
import * as types from "@/store/mutations_types.js"
import { getCookie, delCookie } from "@/util/cookie"
import XLSX from "xlsx"
import locale from 'view-design/dist/locale/en-US';
import { DownloadFile, Translate,  ExceptionHandling, CheckCurrency, CheckFloat } from "@/util/common"
import { AlertInfo } from "@/util/alert"

const authAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL + "auth",
  //  baseURL: 'http://localhost:8000/'
})

authAxiosInstance.interceptors.request.use(
  config => {
    config.headers["Accept-Language"] = store.getters.getLanguage
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Content-Type"] = "application/json"
    if (store.getters.getGroupCode != null) {
      config.headers["selected-group-code"] = store.getters.getGroupCode.code
    }
    return config
  },
  error => {
    store.commit(types.LOADING, false)
    Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      text: Translate("COMMON_MESSAGE_SYSTEM_ERROR"),
    })
    return Promise.reject(error)
  }
)

authAxiosInstance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    store.commit(types.LOADING, false)
    let text = ExceptionHandling(error.response)
    if (error.response.status != 444) {
      Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    }
    return Promise.reject(error)
  }
)

const quotationAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL + "quotation",
  // baseURL: 'http://localhost:8001/'
})

quotationAxiosInstance.interceptors.request.use(
  config => {
    config.headers["Accept-Language"] = store.getters.getLanguage
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Content-Type"] = 'application/json; application/octet-stream'
    if (store.getters.getGroupCode != null) {
      config.headers["selected-group-code"] = store.getters.getGroupCode.code
    }
    return config
  },
  error => {
    store.commit(types.LOADING, false)
    Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      text: Translate("COMMON_MESSAGE_SYSTEM_ERROR"),
    })
    return Promise.reject(error)
  }
)

quotationAxiosInstance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    store.commit(types.LOADING, false)
    let text = ExceptionHandling(error.response)
    if (error.response.status != 444) {
      Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    }
    return Promise.reject(error)
  }
)

const vendorAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL + "vendor",
  // baseURL: 'http://localhost:8002/'
})

vendorAxiosInstance.interceptors.request.use(
  config => {
    config.headers["Accept-Language"] = store.getters.getLanguage
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Content-Type"] = "application/json"
    if (store.getters.getGroupCode != null) {
      config.headers["selected-group-code"] = store.getters.getGroupCode.code
    }
    return config
  },
  error => {
    store.commit(types.LOADING, false)
    Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      text: Translate("COMMON_MESSAGE_SYSTEM_ERROR"),
    })
    return Promise.reject(error)
  }
)

vendorAxiosInstance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    store.commit(types.LOADING, false)
    let text = ExceptionHandling(error.response)
    if (error.response.status != 444) {
      Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    }
    return Promise.reject(error)
  }
)

const fileAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL + "file",
})

fileAxiosInstance.interceptors.request.use(
  config => {
    config.headers["Accept-Language"] = store.getters.getLanguage
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Content-Type"] = "application/json"
    if (store.getters.getGroupCode != null) {
      config.headers["selected-group-code"] = store.getters.getGroupCode.code
    }
    return config
  },
  error => {
    store.commit(types.LOADING, false)
    Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      text: Translate("COMMON_MESSAGE_SYSTEM_ERROR"),
    })
    return Promise.reject(error)
  }
)

fileAxiosInstance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    store.commit(types.LOADING, false)
    let text = ExceptionHandling(error.response)
    if (error.response.status != 444) {
      Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    }
    return Promise.reject(error)
  }
)

const consignmentAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL + "consignment",
  // baseURL: 'http://localhost:8001/'
})

consignmentAxiosInstance.interceptors.request.use(
  config => {
    config.headers["Accept-Language"] = store.getters.getLanguage
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Content-Type"] = "application/json"
    if (store.getters.getGroupCode != null) {
      config.headers["selected-group-code"] = store.getters.getGroupCode.code
    }
    return config
  },
  error => {
    store.commit(types.LOADING, false)
    Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      text: Translate("COMMON_MESSAGE_SYSTEM_ERROR"),
    })
    return Promise.reject(error)
  }
)

consignmentAxiosInstance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    store.commit(types.LOADING, false)
    let text = ExceptionHandling(error.response)
    if (error.response.status != 444) {
      Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$buildErrorMessage = function(error) {
  let text = ""
  if (error.response) {
    if (error.response.status == 401) {
      text = Translate("COMMON_MESSAGE_NOT_AUTH")
    } else if (error.response.data) {
      if (Array.isArray(error.response.data.messages)) {
        error.response.data.messages.forEach(message => {
          text = text.concat(message, "\n")
        })
      } else {
        text = error.response.data
      }
    } else {
      text = Translate("COMMON_MESSAGE_SYSTEM_ERROR")
    }
  }
  return text
}

Vue.prototype.$buildErrorMessageUseHtml = function(error) {
  if (!error.response) {
    return "";
  }
  if (error.response.status === 401) {
    return Translate("COMMON_MESSAGE_NOT_AUTH");
  }
  if (!error.response.data) {
    return Translate("COMMON_MESSAGE_SYSTEM_ERROR");
  }
  if (Array.isArray(error.response.data.messages)) {
    return error.response.data.messages.join("<br>");
  }
  return error.response.data;
}

Vue.prototype.$linkDataControl = function(vueInstance, dataType, dataValue, managerKey, managerType) {
  vueInstance.$authHttp
    .post(
      "data-control",
      JSON.stringify({
        dataType: dataType,
        dataValue: dataValue,
        managerKey: managerKey,
        managerType: managerType,
      })
    )
    .then(response => {
      vueInstance.toggleLoading(false)
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

Vue.prototype.$unlinkDataControl = function(vueInstance, dataControlType, dataControlValue, subjectKey, subjectType) {
  vueInstance.$authHttp
  .delete("data-control/" + dataControlType + "/" + dataControlValue + "/" + subjectType +"/" + subjectKey)
  .then((response) => {
    vueInstance.toggleLoading(false)
  })
  .catch((error) => {
    vueInstance.toggleLoading(false)
    let text = ExceptionHandling(error.response)
    vueInstance.$Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      html: text,
    })
  })
}

Vue.prototype.$getPlantCode = function(vueInstance, groupCodeUuid) {
  return vueInstance.$vendorHttp
    .get("/group-account/" + groupCodeUuid + "/data-control/PLANT")
    .then(response => {
      if (response.data && response.data._embedded) {
        return response.data._embedded.dataControlResourceList
      } else {
        Swal.fire({
          icon: "info",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text: "Plant Code: " +  Translate("COMMON_TEXT_NOTHING"),
        })
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

Vue.prototype.$getPlantCodeWhiteList = function(vueInstance, dataType) {
  return vueInstance.$authHttp
    .get("/data-control/whitelist?dataType=" + dataType)
    .then(response => {
      if (response.data) {
        return response.data
      } else {
        Swal.fire({
          icon: "info",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text: "Plant Code: " +  Translate("COMMON_TEXT_NOTHING"),
        })
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

Vue.prototype.$getMasterData = function(vueInstance, dataType) {
  return vueInstance.$quotationHttp
    .get("/master-data/" + dataType + "/disc")
    .then(response => {
      if (response.data && response.data._embedded) {
        return response.data._embedded.rawMaterialResourceList
      } else {
        Swal.fire({
          icon: "info",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text: "Master Data: " + Translate("COMMON_TEXT_NOTHING"),
        })
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

Vue.prototype.$downloadAttachment = function(vueInstance, uuid) {
  vueInstance.toggleLoading(true)
  vueInstance.$fileHttp
    .get("/attachment/download/" + uuid, { responseType: 'blob' })
    .then((response) => {
      vueInstance.toggleLoading(false)
      DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
      vueInstance.$router.push("/home")
    })
}

Vue.prototype.$downloadMasterAttachment = function(vueInstance, code) {
  vueInstance.toggleLoading(true)
  vueInstance.$fileHttp
    .get("/master-attachment/download/" + code, { responseType: 'blob' })
    .then((response) => {
      vueInstance.toggleLoading(false)
      DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
      vueInstance.$router.push("/home")
    })
}

Vue.prototype.$downloadToolingAttachment = function(vueInstance, quotationUuid, uuid) {
  vueInstance.toggleLoading(true)
  vueInstance.$quotationHttp
    .get("/document/" + quotationUuid + "/tooling-download/" + uuid, { responseType: 'blob' })
    .then((response) => {
      vueInstance.toggleLoading(false)
      DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

Vue.prototype.$queryStatusList = function(vueInstance, queryType) {
  vueInstance.toggleLoading(true)
  return vueInstance.$quotationHttp
    .get(queryType + "/status-list")
    .then(response => {
      vueInstance.toggleLoading(false)
      return response.data._embedded.quotationFlowStatusViewDtoList
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
      vueInstance.$router.push("/home")
    })
}

Vue.prototype.$queryHighPriceBgBu = function(vueInstance, queryType) {
  vueInstance.toggleLoading(true)
  return vueInstance.$quotationHttp
    .get("high-price-workflow-master/" + queryType)
    .then(response => {
      console.log(response);
      return response.data
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
      vueInstance.$router.push("/home")
    })
}

Vue.prototype.$queryHighPriceReasonCategory = function(vueInstance) {
  vueInstance.toggleLoading(true)
  return vueInstance.$quotationHttp
    .get("/high-price-reason-category?enabled=true")
    .then(response => {
      return response.data._embedded.highPriceReasonCategoryResourceList;
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
      vueInstance.$router.push("/home")
    })
}

Vue.prototype.$queryQuotationMaster = function(vueInstance, data, queryType, pageObj) {
  return vueInstance.$quotationHttp
    .post(queryType + "/search?page=" + pageObj.page + '&size=' + pageObj.pageSize + (pageObj.sort === undefined || Array.isArray(pageObj.sort) === false || pageObj.sort.length === 0 ? "" : "&sort=" + pageObj.sort.join("&sort=")), JSON.stringify(data))
    .then((response) => {
      if (response.data._embedded) {
        return response.data
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

Vue.prototype.$queryHighPriceQuotationMaster = function(vueInstance, data, queryType, pageObj) {
  return vueInstance.$quotationHttp
    .post(queryType + "/cpcHighPriceQuotationSearch?page=" + pageObj.page + '&size=' + pageObj.pageSize + (pageObj.sort === undefined || Array.isArray(pageObj.sort) === false || pageObj.sort.length === 0 ? "" : "&sort=" + pageObj.sort.join("&sort=")), JSON.stringify(data))
    .then((response) => {
      if (response.data._embedded) {
        return response.data
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

Vue.prototype.$queryQuotationMasterGroup = function(vueInstance, data, queryType, pageObj) {
  return vueInstance.$quotationHttp
    .post(queryType + "/group-search?page=" + pageObj.page + '&size=' + pageObj.pageSize, JSON.stringify(data))
    .then((response) => {
      if (response.data._embedded) {
        return response.data
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

Vue.prototype.$queryPlmDocuments = function(vueInstance, quotationId) {
  return vueInstance.$quotationHttp
    .get("/document/specs/" + quotationId)
    .then((response) => {
      if (response.data._embedded != undefined) {
        return response.data._embedded.quotationSpecDocumentResourceList
      } else {
        return null
      }
    })
}

Vue.prototype.$queryReferencePrice = function(vueInstance, quotationId) {
  return vueInstance.$quotationHttp
    .get("/maintain/refPrice/" + quotationId)
    .then((response) => {
      if (response.data._embedded != undefined) {
        return response.data._embedded.quotationReferencePriceResourceList
      } else {
        return null
      }
    })
}


Vue.prototype.$queryAbnormals = function(vueInstance, quotationId) {
  return vueInstance.$quotationHttp
    .get("/maintain/abnormals/" + quotationId)
    .then((response) => {
      if (response.data._embedded != undefined) {
        return response.data._embedded.quotationAbnormalResourceList
      } else {
        return null
      }
    })
}


Vue.prototype.$queryQuotationLog = function(vueInstance, quotationId) {
  return vueInstance.$quotationHttp
    .get("/quotation/logs/" + quotationId)
    .then((response) => {
      if (response.data._embedded != undefined) {
        return response.data._embedded.quotationFlowLogResourceList
      } else {
        return [];
      }
    })
}

Vue.prototype.$getReferenceData = function(vueInstance, url) {
  return vueInstance.$quotationHttp
  .get(url)
  .then((response) => {
    if (response.data && response.data.length > 0) {
      return response.data
    } else {
      vueInstance.$Swal.fire({
        icon: "info",
        title: Translate("COMMON_MESSAGE_ERROR"),
        text: Translate("COMMON_TEXT_NOTHING"),
      })
    }
  })
  .catch((error) => {
    vueInstance.toggleLoading(false)
    let text = ExceptionHandling(error.response)
    vueInstance.$Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      html: text,
    })
  })
}

Vue.prototype.$toolingUpdate = function(vueInstance, tooling) {
  vueInstance.$quotationHttp
  .post("/tooling/update", JSON.stringify(tooling))
  .then((response) => {
  })
  .catch(() => {})
}

Vue.prototype.$buildMenuPage = function(vueInstance, userPages) {
  var tempPages = Object.assign([], userPages)
  let menuOptionsLeft = []

  menu.forEach(tree => {
    let subMenuOptions = []
    tree.children.forEach(page => {
      if (tempPages.some(userPage => userPage == page.code)) {
        subMenuOptions.push({
          type: "link",
          text: vueInstance.$t(page.name),
          path: { name: `${page.name}` },
          iconLeft: `<i class="fa ${page.icon}"></i>`,
        })
      }
    })

    if (subMenuOptions.length > 0) {
      menuOptionsLeft.push({
        type: "link",
        text: vueInstance.$t(tree.name),
        subMenuOptions,
      })
    }
  })
  vueInstance.setMenuOptionsLeft(menuOptionsLeft)
}

Vue.prototype.$readTooling = function(vueInstance, formNo, isSupplier) {
  if (isSupplier) {
    return vueInstance.$quotationHttp
    .get("supplier/tooling/search/" + formNo)
    .then((response) => {
      return response.data
    })
    .catch(() => {})
  } else {
    return vueInstance.$quotationHttp
    .get("tooling/search/" + formNo)
    .then((response) => {
      return response.data
    })
    .catch(() => {})
  }
}

Vue.prototype.$downloadExcel = function(vueInstance, url, queryData, pageable) {
  vueInstance.toggleLoading(true)
  vueInstance.$quotationHttp
    .post("/" + url + "/download" + pageable, queryData, { responseType: 'blob' })
    .then((response) => {
      vueInstance.toggleLoading(false)
      if (response.data) {
        DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
      }
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = "records to many, please fill in criteria or give a start and size of records."
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

Vue.prototype.$getDownloadExcel = function(vueInstance, url, pageable) {
  vueInstance.toggleLoading(true)
  vueInstance.$quotationHttp
    .get("/" + url + "/download" + pageable, { responseType: 'blob' })
    .then((response) => {
      vueInstance.toggleLoading(false)
      if (response.data) {
        DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
      }
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = "records to many, please fill in criteria or give a start and size of records."
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

Vue.prototype.$readerWorkBookFromLocal = function(file) {
  const reader = new FileReader()
  reader.readAsBinaryString(file)
  return new Promise(function (resolve, reject) {
    reader.onload = function (e) {
      const fileData = e.target.result
      if (reader.readyState === 2) {
        const workBook = XLSX.read(fileData, { type: "binary" })
        resolve(workBook)
      } else {
        reject("讀取文件失敗")
      }
    }
  })
}

Vue.prototype.$readUserDetail = function(vueInstance) {
  vueInstance.toggleLoading(true)
  vueInstance.$authHttp
    .get("current-user")
    .then((response) => {
      if (response.data && response.data.ecGroups && response.data.ecGroups.length > 0) {
        var groupDatas = response.data.ecGroups.sort(function(a, b) {
          return a.code.localeCompare(b.code, "en");
        })
        if (getCookie('userCode')) { // 若 cookie 有 userCode 則優先採用
          let cookieGroup = groupDatas.find(item => item.code === getCookie('userCode'))
          vueInstance.setGroupCode(cookieGroup)
        }
        else {
          vueInstance.setGroupCode(groupDatas[0])
        }

        vueInstance.$authHttp
          .get("current-user")
          .then((response) => {
            response.data.ecGroups = groupDatas
            vueInstance.setUserProfile(response.data)
          })
          .catch(() => {})
          .finally(() => {
            this.toggleLoading(false)
          })
      } else {
        vueInstance.toggleLoading(false)
        vueInstance.setUserProfile(response.data)
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      vueInstance.setLogin(false)
      delCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

Vue.prototype.$searchSupplierOthers = function(vueInstance) {
  vueInstance.$resetSupplierData(vueInstance)
  vueInstance.$resetScalePrice(vueInstance)
  vueInstance.rawMaterialType= ""
  vueInstance.rawMaterialPrice = ""
  return vueInstance.$quotationHttp
    .get("supplier/detail/" + vueInstance.uuid)
    .then((response) => {
      vueInstance.quotation = response.data
      if (vueInstance.quotation.scalePrices) {
        let tempArray = []
        vueInstance.scalePriceList.forEach(price => {
          let flag = true
          vueInstance.quotation.scalePrices.forEach(element => {
            if (price.item.toString() == element.item.toString()) {
              tempArray.push(element)
              flag = false
            }
          });
          if (flag) {
            tempArray.push(price)
          }
        })
        vueInstance.scalePriceList = tempArray
      } else {
        vueInstance.quotation.scalePrices = []
      }

      if (vueInstance.quotation.plmQuotationDocuments) {
        vueInstance.plmQuotationDocuments = vueInstance.quotation.plmQuotationDocuments
      } else {
        vueInstance.quotation.plmQuotationDocuments = []
      }

      if (vueInstance.quotation.supplierQuotationFiles) {
        vueInstance.supplierQuotationFiles = vueInstance.quotation.supplierQuotationFiles
        vueInstance.showSupplierQuotationFiles = vueInstance.supplierQuotationFiles.filter(attachment => attachment.deleted == false)
      } else {
        vueInstance.quotation.supplierQuotationFiles = []
      }

      if (vueInstance.quotation.cpcToVendorAttachments) {
        vueInstance.cpcToVendorAttachments = vueInstance.quotation.cpcToVendorAttachments.filter(attachment => attachment.deleted == false)
      } else {
        vueInstance.quotation.cpcToVendorAttachments = []
      }

      if (vueInstance.quotation.price) {
        vueInstance.price = vueInstance.quotation.price
      }

      if (vueInstance.quotation.rawMaterialType) {
        vueInstance.rawMaterialType = vueInstance.quotation.rawMaterialType
      }

      if (vueInstance.quotation.rawMaterialPrice) {
        vueInstance.rawMaterialPrice = vueInstance.quotation.rawMaterialPrice
      }

      if (vueInstance.quotation.comments) {
        vueInstance.comments = vueInstance.quotation.comments
      }
      return vueInstance
    })
    .catch((error) => {
      console.log(error)
    })
}


Vue.prototype.$resetScalePrice = function(vueInstance) {
  vueInstance.scalePriceList = [{
      item: '2',
      scaleQuantity: '',
      scalePrice: ''
    },
    {
      item: '3',
      scaleQuantity: '',
      scalePrice: ''
    },
        {
      item: '4',
      scaleQuantity: '',
      scalePrice: ''
    },
      {
      item: '5',
      scaleQuantity: '',
      scalePrice: ''
    }
  ]
}

Vue.prototype.$resetSupplierData = function(vueInstance)  {
  vueInstance.price = ""
  vueInstance.comments = ""
  vueInstance.supplierQuotationFiles = []
  vueInstance.showSupplierQuotationFiles = []
  vueInstance.plmQuotationDocuments = []
  vueInstance.cpcToSupplierAttachments = []
}

Vue.prototype.$searchSupplierNormal = function(vueInstance) {
  vueInstance.$resetSupplierData(vueInstance)
  vueInstance.$quotationHttp
    .get("supplier/detail/" + vueInstance.uuid)
    .then((response) => {
      vueInstance.quotation = response.data

      if (vueInstance.quotation.plmQuotationDocuments) {
        vueInstance.plmQuotationDocuments = vueInstance.quotation.plmQuotationDocuments
      } else {
        vueInstance.quotation.plmQuotationDocuments = []
      }

      if (vueInstance.quotation.supplierQuotationFiles) {
        vueInstance.supplierQuotationFiles = vueInstance.quotation.supplierQuotationFiles
        vueInstance.showSupplierQuotationFiles = vueInstance.supplierQuotationFiles.filter(attachment => attachment.deleted == false)
      }

      if (vueInstance.quotation.cpcToSupplierAttachments) {
        vueInstance.cpcToSupplierAttachments = vueInstance.quotation.cpcToSupplierAttachments.filter(attachment => attachment.deleted == false)
      } else {
        vueInstance.quotation.cpcToSupplierAttachments = []
      }

      if (vueInstance.quotation.price) {
        vueInstance.price = vueInstance.quotation.price
      }

      if (vueInstance.quotation.comments) {
        vueInstance.comments = vueInstance.quotation.comments
      }
    })
    .catch(() => {
    })
}


Vue.prototype.$searchSupplierTooling = function(vueInstance) {
  vueInstance.$searchSupplierNormal(vueInstance)
  return vueInstance.$quotationHttp
    .get("supplier/tooling/search/" + vueInstance.formNo)
    .then((response) => {
      vueInstance.tooling = response.data
      if (vueInstance.tooling.attribute == undefined) {
        vueInstance.tooling.attribute = {
          leadTime: '',
          cavity: '',
          lifeTime: '',
          cycleTime: '',
          length: '',
          machineTonnage: '',
          totalWeight: '',
          width: '',
          baseMaterial: '',
          otherAccessories: '',
          height: '',
          managementProfit: '',
          designAndTestingPrice: '',
          otherAccessoryTotalPrice: '',
          formworkPrice: '',
          coldHotRunner: '',
          numberOfStep: '',
          numberOfSlider: '',
          dryWetProcess: '',
          molds: [],
          engineerings: []
        }
      }
      if (vueInstance.tooling.attribute.molds === undefined) {
        vueInstance.tooling.attribute.molds = []
        vueInstance.molds = []
      } else {
        vueInstance.molds = vueInstance.tooling.attribute.molds
      }

      if (vueInstance.tooling.attribute.engineerings === undefined) {
        vueInstance.tooling.attribute.engineerings = []
        vueInstance.engineerings = []
      } else {
        vueInstance.engineerings = vueInstance.tooling.attribute.engineerings
      }

      if (vueInstance.tooling.materials === undefined) {
        vueInstance.tooling.materials = []
      }

      if (vueInstance.tooling.attachments === undefined) {
        vueInstance.tooling.attachments = []
      }
      return vueInstance
    })
    .catch(() => {
    })
}

Vue.prototype.$searchSupplierMetal = function(vueInstance) {
  vueInstance.$searchSupplierNormal(vueInstance)
  vueInstance.priceList = []
  vueInstance.priceList.push({
    key: "RM_COST",
    value: vueInstance.metalQuotation.rmCost
  })
  vueInstance.priceList.push({
    key: "PROCESSING_COST",
    value: vueInstance.metalQuotation.processingCost
  })
  vueInstance.priceList.push({
    key: "TREATMENT",
    value: vueInstance.metalQuotation.treatmentCost
  })
  vueInstance.priceList.push({
    key: "ACCESSORIES",
    value: vueInstance.metalQuotation.accessoriesCost
  })
  vueInstance.priceList.push({
    key: "OTHERS_PROCESS",
    value: vueInstance.metalQuotation.others
  })
  vueInstance.priceList.push({
    key: "RM_RATIO_NO_ACCESSORY",
    value: vueInstance.metalQuotation.rmRatio
  })
  vueInstance.priceList.push({
    key: "TOTAL_COST",
    value: vueInstance.metalQuotation.totalCost
  })
  return vueInstance.$quotationHttp
    .get("metal/formNo/" + vueInstance.formNo)
    .then((response) => {
      if (response.data === "No Data") {
        vueInstance.metalQuotation = {
          length: '',
          width: '',
          height: '',
          weight: '',
          rawMaterialType: {
            partNo: '',
            partNoDesc: ''
          },
          rmVendor: {
            vendorCode: ''
          },
          coilCenter: {
            vendorCode: ''
          },
          rmPrice: '',
          rmPriceDate: '',
          rmCost: '',
          processingCost: '',
          treatmentCost: '',
          accessoriesCost: '',
          others: '',
          rmRatio: '',
          totalCost: '',
          supplierRemark: ''
        }
        // vueInstance.rawMaterialDesc = ""
        vueInstance.rmVendorName = ""
        vueInstance.coilCenterName = ""
      } else {
        vueInstance.metalQuotation = response.data
        vueInstance.rawMaterialDesc = vueInstance.metalQuotation.rawMaterialType.partNoDesc
        vueInstance.rmVendorName = vueInstance.metalQuotation.rmVendor.vendorName
        vueInstance.coilCenterName = vueInstance.metalQuotation.coilCenter.vendorName
        vueInstance.$getReferenceData(vueInstance, "/steel-reference-price/find/vendor/" + vueInstance.metalQuotation.rawMaterialType.uuid).then(data => {
          vueInstance.rmVendors = data
        })  
        vueInstance.$getDistributorByVendor(vueInstance, "STEEL", vueInstance.metalQuotation.rmVendor.vendorCode).then(data => {
          vueInstance.coilCenters = data
        })  
        vueInstance.priceList.forEach(price => {
          if (price.key == "RM_COST") {
            price.value = vueInstance.metalQuotation.rmCost
          } else if (price.key == "PROCESSING_COST") {
            price.value = vueInstance.metalQuotation.processingCost
          } else if (price.key == "TREATMENT") {
            price.value = vueInstance.metalQuotation.treatmentCost
          } else if (price.key == "ACCESSORIES") {
            price.value = vueInstance.metalQuotation.accessoriesCost
          } else if (price.key == "OTHERS_PROCESS") {
            price.value = vueInstance.metalQuotation.others
          } else if (price.key == "RM_RATIO_NO_ACCESSORY") {
            price.value = vueInstance.metalQuotation.rmRatio
          } else if (price.key == "TOTAL_COST") {
            price.value = vueInstance.metalQuotation.totalCost
          }
        }) 
      }
      return vueInstance
    })
}

Vue.prototype.$searchSupplierPlastic = function(vueInstance) {
  vueInstance.$searchSupplierNormal(vueInstance)
  vueInstance.priceList = []
  vueInstance.priceList.push({
    key: "RM_COST",
    value: vueInstance.plasticQuotation.rmCost
  })
  vueInstance.priceList.push({
    key: "INJECTION_COST",
    value: vueInstance.plasticQuotation.injectionCost
  })
  vueInstance.priceList.push({
    key: "PROCESSING_COST",
    value: vueInstance.plasticQuotation.processingCost
  })
  vueInstance.priceList.push({
    key: "ACCESSORIES",
    value: vueInstance.plasticQuotation.accessoriesCost
  })
  vueInstance.priceList.push({
    key: "OTHERS_PROCESS",
    value: vueInstance.plasticQuotation.others
  })
  vueInstance.priceList.push({
    key: "RM_RATIO_NO_ACCESSORY",
    value: vueInstance.plasticQuotation.rmRatio
  })
  vueInstance.priceList.push({
    key: "TOTAL_COST",
    value: vueInstance.plasticQuotation.totalCost
  })
  return vueInstance.$quotationHttp
    .get("plastic/formNo/" + vueInstance.formNo)
    .then((response) => {
      if (response.data === "No Data") {
        vueInstance.plasticQuotation = {
          length: '',
          width: '',
          height: '',
          weight: '',
          model: '',
          resinType: {
            type: ''
          },
          resinVendor: {
            vendorCode: ''
          },
          resinNo: {
            partNo: '',
            partNoDesc: ''
          },
          distributor: {
            vendorCode: ''
          },
          resinColor: '',
          colorNo: '',
          rmPrice: '',
          rmPriceDate: '',
          dyeCost: '',
          cavity: '',
          tannage: '',
          hourlyRate: '',
          cycleTime: '',
          rmCost: '',
          injectingCost: '',
          processingCost: '',
          treatmentCost: '',
          accessoriesCost: '',
          others: '',
          rmRatio: '',
          totalCost: '',
          supplierRemark: ''
        }
        vueInstance.resinType = ""
        // vueInstance.resinVendor = ""
        vueInstance.resinNo = ""
        vueInstance.distributor = ""
      } else {
        vueInstance.plasticQuotation = response.data
        vueInstance.resinType = vueInstance.plasticQuotation.resinType.type
        vueInstance.resinVendor = vueInstance.plasticQuotation.resinVendor.vendorName
        vueInstance.resinNo = vueInstance.plasticQuotation.resinNo.partNoDesc
        vueInstance.distributor = vueInstance.plasticQuotation.distributor.vendorName
        vueInstance.$getReferenceData(vueInstance, "/resin-reference-price/find/resinNo/"  + vueInstance.plasticQuotation.resinVendor.uuid).then(data => {
          vueInstance.resinNos = data
        })  
        
        vueInstance.$getDistributorByVendor(vueInstance, "RESIN",  vueInstance.plasticQuotation.resinVendor.vendorCode).then(data => {
          vueInstance.distributors = data
        })
        vueInstance.priceList.forEach(price => {
          if (price.key == "RM_COST") {
            price.value = vueInstance.plasticQuotation.rmCost
          } else if (price.key == "INJECTION_COST") {
            price.value = vueInstance.plasticQuotation.injectionCost
          } else if (price.key == "PROCESSING_COST") {
            price.value = vueInstance.plasticQuotation.processingCost
          } else if (price.key == "ACCESSORIES") {
            price.value = vueInstance.plasticQuotation.accessoriesCost
          } else if (price.key == "OTHERS_PROCESS") {
            price.value = vueInstance.plasticQuotation.others
          } else if (price.key == "RM_RATIO_NO_ACCESSORY") {
            price.value = vueInstance.plasticQuotation.rmRatio
          } else if (price.key == "TOTAL_COST") {
            price.value = vueInstance.plasticQuotation.totalCost
          }
        }) 
      }
      return vueInstance
    })
}

Vue.prototype.$searchSupplierPwb = function(vueInstance) {
  vueInstance.$searchSupplierNormal(vueInstance)
  vueInstance.toggleLoading(true)
  return vueInstance.$quotationHttp
    .get("supplier/pwb/formNo/" + vueInstance.formNo)
    .then((response) => {
      vueInstance.$getReferenceData(vueInstance, "pwb-Cost-Item-Master/findAll").then(data => {
        vueInstance.processCostItemArray = []
        vueInstance.surfaceCostItemArray = []
        data.forEach(pwbCostItem => {
          if (pwbCostItem.type == "PROCESS") {
            vueInstance.processCostItemArray.push(pwbCostItem)
          } else if (pwbCostItem.type == "SURFACE") {
            vueInstance.surfaceCostItemArray.push(pwbCostItem)
          }
        })
      }).catch((error) => {
        AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
        })
      }).finally(() => {
        vueInstance.toggleLoading(false)
      })

      if (response.data === "No Data") {
      } else {
        vueInstance.pwbQuotation = response.data
        vueInstance.quotation.quoteExchangeRate = response.data.quoteExchangeRate
        if (vueInstance.pwbQuotation.mainSourceCclSupplier) {
          vueInstance.mainSourceCclSupplier = vueInstance.pwbQuotation.mainSourceCclSupplier.vendorName
        }
        if (vueInstance.pwbQuotation.mainCoreUlNumber) {
          vueInstance.mainCoreUlNumber = vueInstance.pwbQuotation.mainCoreUlNumber.partNoDesc
        }
        if (vueInstance.pwbQuotation.secondSourceCclSupplier) {
          vueInstance.secondSourceCclSupplier = vueInstance.pwbQuotation.secondSourceCclSupplier.vendorName
        } 
        if (vueInstance.pwbQuotation.secondCoreUlNumber) {
          vueInstance.secondCoreUlNumber = vueInstance.pwbQuotation.secondCoreUlNumber.partNoDesc
        }

        vueInstance.priceList = []
        vueInstance.priceList.push({
          key: "MATERIAL_COST",
          value: vueInstance.pwbQuotation.materialCost
        })
        vueInstance.priceList.push({
          key: "SURFACE_FINISH_COST",
          value: vueInstance.pwbQuotation.surfaceFinishCost
        })
        vueInstance.priceList.push({
          key: "PROCESSING_COST",
          value: vueInstance.pwbQuotation.processCost
        })
        vueInstance.priceList.push({
          key: "DELTA_PN_UP_PRICE_USD",
          value: vueInstance.pwbQuotation.deltaPnPriceUsd
        })
        vueInstance.priceList.push({
          key: "DELTA_PN_UP_PRICE",
          value: vueInstance.pwbQuotation.deltaPnPrice
        })
        vueInstance.priceList.push({
          key: "SPECIAL_COST_DOWN",
          value: vueInstance.pwbQuotation.specialCostDown
        })
        console.log(vueInstance.pwbQuotation)
        if (vueInstance.pwbQuotation.pwbCostItems) {
          vueInstance.processCostItems = []
          vueInstance.surfaceCostItems = []
          vueInstance.pwbQuotation.pwbCostItems.forEach(pwbCostItem => {
            if (pwbCostItem.type == "PROCESS") {
              vueInstance.processCostItems.push(pwbCostItem)
            } else if (pwbCostItem.type == "SURFACE") {
              vueInstance.surfaceCostItems.push(pwbCostItem)
            }
          })
        }

        vueInstance.$getReferenceData(vueInstance, "pcbMaster/find/paramter/" + vueInstance.pwbQuotation.cclLaminateType).then(data => {
          vueInstance.toggleLoading(false)
          data.forEach(temp => {
            if (temp.key == "Layer") {
              vueInstance.layers = temp.datas
            }
            if (temp.key == "PcbThickness") {
              vueInstance.pcbThicknesses = temp.datas
            }
          })
        }).catch((error) => {
          console.log(error)
          vueInstance.toggleLoading(false)
          AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
          })
        })

        vueInstance.$searchPcbMaster(vueInstance, true)

        vueInstance.$getReferenceData(vueInstance, "cclMaster/find/paramter/" + vueInstance.pwbQuotation.cclLaminateType).then(data => {
          data.forEach(temp => {
            if (temp.key == "Tg") {
              vueInstance.tgs = temp.datas
            }
            if (temp.key == "ExternalCopperThickness") {
              vueInstance.externalCopperThicknesses = temp.datas
            }
            if (temp.key == "InternalCopperThickness") {
              vueInstance.internalCopperThicknesses = temp.datas
            }
            if (temp.key == "InternalCoreThickness") {
              vueInstance.internalCoreThicknesses = temp.datas
            }
            if (temp.key == "CclSupplier") {
              vueInstance.cclSuppliers = temp.datas
            }
            if (temp.key == "CoreUlNumber") {
              vueInstance.coreUlNumbers = temp.datas
            }
          })
        }).catch((error) => {
          console.log(error)
          vueInstance.toggleLoading(false)
          AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
          })
        })
      } 
      return vueInstance
    }).catch((error) => {
    })
}

Vue.prototype.$searchMainCoreUpPrice = function(vueInstance) {
  if (vueInstance.pwbQuotation && vueInstance.pwbQuotation.cclLaminateType && 
    vueInstance.pwbQuotation.mainSourceCclSupplier && vueInstance.pwbQuotation.mainSourceCclSupplier.uuid &&
    vueInstance.pwbQuotation.mainCoreUlNumber && vueInstance.pwbQuotation.mainCoreUlNumber.uuid && 
    (vueInstance.pwbQuotation.externalCopperThickness || vueInstance.pwbQuotation.externalCopperThickness === 0) && 
    (vueInstance.pwbQuotation.internalCopperThickness || vueInstance.pwbQuotation.internalCopperThickness === 0) &&
    (vueInstance.pwbQuotation.internalCoreThickness || vueInstance.pwbQuotation.internalCoreThickness === 0)) {
    return vueInstance.$quotationHttp
      .post("cclMaster/find/upPrice", JSON.stringify({
        "cclLaminateType": vueInstance.pwbQuotation.cclLaminateType,
        "cclSupplierId": vueInstance.pwbQuotation.mainSourceCclSupplier.uuid,
        "coreUlNumberId": vueInstance.pwbQuotation.mainCoreUlNumber.uuid,
        "externalCopperThickness": vueInstance.pwbQuotation.externalCopperThickness,
        "internalCopperThickness": vueInstance.pwbQuotation.internalCopperThickness,
        "internalCoreThickness": vueInstance.pwbQuotation.internalCoreThickness,
        "enabled": true
      }))
      .then((response) => {
        if (response) {
          return response.data
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.toggleLoading(false)
      })
  } else {
    return new Promise((resolve, reject) => {
    });
  }
}

Vue.prototype.$searchSecondCoreUpPrice = function(vueInstance) {
  if (vueInstance.pwbQuotation && vueInstance.pwbQuotation.cclLaminateType && 
    vueInstance.pwbQuotation.secondSourceCclSupplier && vueInstance.pwbQuotation.secondSourceCclSupplier.uuid &&
    vueInstance.pwbQuotation.secondCoreUlNumber && vueInstance.pwbQuotation.secondCoreUlNumber.uuid && 
    (vueInstance.pwbQuotation.externalCopperThickness || vueInstance.pwbQuotation.externalCopperThickness === 0) && 
    (vueInstance.pwbQuotation.internalCopperThickness || vueInstance.pwbQuotation.internalCopperThickness === 0) &&
    (vueInstance.pwbQuotation.internalCoreThickness || vueInstance.pwbQuotation.internalCoreThickness === 0)) {
    return vueInstance.$quotationHttp
      .post("cclMaster/find/upPrice", JSON.stringify({
        "cclLaminateType": vueInstance.pwbQuotation.cclLaminateType,
        "cclSupplierId": vueInstance.pwbQuotation.secondSourceCclSupplier.uuid,
        "coreUlNumberId": vueInstance.pwbQuotation.secondCoreUlNumber.uuid,
        "externalCopperThickness": vueInstance.pwbQuotation.externalCopperThickness,
        "internalCopperThickness": vueInstance.pwbQuotation.internalCopperThickness,
        "internalCoreThickness": vueInstance.pwbQuotation.internalCoreThickness,
        "enabled": true
      }))
      .then((response) => {
        if (response) {
          return response.data
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.toggleLoading(false)
      })
  } else {
    return new Promise((resolve, reject) => {
    });
  }
}

Vue.prototype.$searchPcbMaster = function(vueInstance) {
  if (vueInstance.showStepThree && vueInstance.quotation && vueInstance.quotation.cpcAccount && vueInstance.quotation.vendorCode &&
    vueInstance.pwbQuotation && vueInstance.pwbQuotation.cclLaminateType && 
    (vueInstance.pwbQuotation.layer || vueInstance.pwbQuotation.layer === 0) &&
    (vueInstance.pwbQuotation.internalCopperThickness || vueInstance.pwbQuotation.internalCopperThickness === 0) &&
    (vueInstance.pwbQuotation.externalCopperThickness || vueInstance.pwbQuotation.externalCopperThickness === 0) &&
    (vueInstance.pwbQuotation.pcbThickness || vueInstance.pwbQuotation.pcbThickness === 0)
    ) {
    vueInstance.toggleLoading(true)
    vueInstance.$quotationHttp
    .post("pcbMaster/find", JSON.stringify({
      "cpcAccount": vueInstance.quotation.cpcAccount,
      "pcbVnCode": vueInstance.quotation.vendorCode ? vueInstance.quotation.vendorCode.replace(/\b(0+)/gi,"") : "",
      "cclLaminateType": vueInstance.pwbQuotation.cclLaminateType,
      "layer": vueInstance.pwbQuotation.layer,
      "internalCopperThickness": vueInstance.pwbQuotation.internalCopperThickness,
      "externalCopperThickness": vueInstance.pwbQuotation.externalCopperThickness,
      "pcbThickness": vueInstance.pwbQuotation.pcbThickness,
      "tg": vueInstance.pwbQuotation.tg,
      "enabled": true
    }))
    .then((response) => {
      if (response.data) {
        if (vueInstance.pwbQuotation.rfqBase == "SHEET_BASE") {
          vueInstance.pwbQuotation.pcbPrice = response.data.pcbPriceSheetBase
        } else if (vueInstance.pwbQuotation.rfqBase == "ACTUAL_PANEL_BASE") {
          vueInstance.pwbQuotation.pcbPrice = response.data.pcbPriceActualPanelBase
        } 
        vueInstance.pcbMaster = response.data
        vueInstance.canModifyPcbPrice = true
      } else {
        vueInstance.pwbQuotation.pcbPrice = ""
        vueInstance.pcbMaster = {}
        vueInstance.canModifyPcbPrice = false
      }
      vueInstance.$buildPcbPriceList(vueInstance, false)
    })
    .catch(() => {
    })
    .finally(() => {
      vueInstance.toggleLoading(false)
    })
  } 
}

Vue.prototype.$buildPcbPriceList = function(vueInstance, isCostItem) {
  if (vueInstance.pwbQuotation.pnInSheet) {
    vueInstance.priceList.forEach(price => {
      if (price.key == "MATERIAL_COST") {
        if (vueInstance.pwbQuotation.rfqBase == "SHEET_BASE") {
          vueInstance.pwbQuotation.materialCost = (Number(vueInstance.pwbQuotation.pcbPrice) / Number(vueInstance.pwbQuotation.pnInSheet)).toFixed(4)
        } else if (vueInstance.pwbQuotation.rfqBase == "ACTUAL_PANEL_BASE") {
          vueInstance.pwbQuotation.materialCost = (Number(vueInstance.pwbQuotation.area) * Number(vueInstance.pwbQuotation.pcbPrice) / Number(vueInstance.pwbQuotation.pnInPanel)).toFixed(4)
        } 
        price.value = vueInstance.pwbQuotation.materialCost
      }
      if (price.key == "SURFACE_FINISH_COST") {
        vueInstance.pwbQuotation.surfaceFinishCost = 0
        vueInstance.surfaceCostItems.forEach(item => {
          vueInstance.pwbQuotation.surfaceFinishCost = (Number(vueInstance.pwbQuotation.surfaceFinishCost) + Number(item.unitPriceForPcsSheet)).toFixed(4)
        })
        price.value = vueInstance.pwbQuotation.surfaceFinishCost
      }
      if (price.key == "PROCESSING_COST") {
        vueInstance.pwbQuotation.processCost = 0
        vueInstance.processCostItems.forEach(item => {
          vueInstance.pwbQuotation.processCost = (Number(vueInstance.pwbQuotation.processCost) + Number(item.unitPriceForPcsSheet)).toFixed(4)
        })
        price.value = vueInstance.pwbQuotation.processCost
      }
      if (price.key == "DELTA_PN_UP_PRICE_USD") {
        vueInstance.pwbQuotation.deltaPnPriceUsd = ((Number(vueInstance.pwbQuotation.materialCost) + Number(vueInstance.pwbQuotation.surfaceFinishCost) + Number(vueInstance.pwbQuotation.processCost)) * (Number(1) - Number(vueInstance.pwbQuotation.specialCostDown) / 100)).toFixed(4)
        price.value = vueInstance.pwbQuotation.deltaPnPriceUsd
      } 
      if (price.key == "DELTA_PN_UP_PRICE") {
        vueInstance.pwbQuotation.deltaPnPrice = ((Number(vueInstance.pwbQuotation.materialCost) + Number(vueInstance.pwbQuotation.surfaceFinishCost) + Number(vueInstance.pwbQuotation.processCost)) * (Number(1) - Number(vueInstance.pwbQuotation.specialCostDown) / 100) * Number(vueInstance.cpcExchangeRate)).toFixed(4)
        price.value = vueInstance.pwbQuotation.deltaPnPrice
      } 
      if (!isCostItem && price.key == "SPECIAL_COST_DOWN") {
        vueInstance.pwbQuotation.specialCostDown = 0
        price.value = 0
      } 
    })
  }
}

Vue.prototype.$getVendorByDistributor = function(vueInstance, type, vendorCode) {
  return vueInstance.$quotationHttp
  .get("/rm-distributor/find/vendor/" + type + "/" + vendorCode)
  .then((response) => {
    if (response.data && response.data.length > 0) {
      return response.data
    } else {
      vueInstance.$Swal.fire({
        icon: "info",
        title: Translate("COMMON_MESSAGE_ERROR"),
        text: Translate("COMMON_TEXT_NOTHING"),
      })
    }
  })
  .catch((error) => {
    vueInstance.toggleLoading(false)
    let text = ExceptionHandling(error.response)
    vueInstance.$Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      html: text,
    })
  })
}

Vue.prototype.$getDistributorByVendor = function(vueInstance, type, vendorCode) {
  return vueInstance.$quotationHttp
  .get("/rm-distributor/find/distributor/" + type + "/" + vendorCode)
  .then((response) => {
    if (response.data && response.data.length > 0) {
      return response.data
    } else {
      vueInstance.$Swal.fire({
        icon: "info",
        title: Translate("COMMON_MESSAGE_ERROR"),
        text: Translate("COMMON_TEXT_NOTHING"),
      })
    }
  })
  .catch((error) => {
    vueInstance.toggleLoading(false)
    let text = ExceptionHandling(error.response)
    vueInstance.$Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      html: text,
    })
  })
}

Vue.prototype.$getRmType = function(vueInstance, enabled) {
  return vueInstance.$quotationHttp
  .get("/rmType/find/" + enabled)
  .then((response) => {
    if (response.data && response.data.length > 0) {
      return response.data
    } else {
      vueInstance.$Swal.fire({
        icon: "info",
        title: Translate("COMMON_MESSAGE_ERROR"),
        text: vueInstance.$t('RM_TYPE') + " " +  Translate("COMMON_TEXT_NOTHING"),
      })
    }
  })
  .catch((error) => {
    vueInstance.toggleLoading(false)
    let text = ExceptionHandling(error.response)
    vueInstance.$Swal.fire({
      icon: "error",
      title: Translate("COMMON_MESSAGE_ERROR"),
      html: text,
    })
  })
}

Vue.prototype.$validSupplierAttachments = function(vueInstance, fileLength) {
  let errorMessage = ""
  if (fileLength === 0) {
    errorMessage = vueInstance.$t('PLEASE_UPLOAD_SUPPLIER_ATTACHEMENT') + " <br>"
  }
  return errorMessage
}

Vue.prototype.$showMetalCategoryAttribute = function(vueInstance, formNo) {
  vueInstance.metalQuotation = {}
  vueInstance.metalAttributeModel = true
  vueInstance.plasticAttributeModel = false
  vueInstance.pwbAttributeModel = false
  vueInstance.toggleLoading(true)
  vueInstance.$quotationHttp
    .get("metal/formNo/" + formNo)
    .then((response) => {
      vueInstance.toggleLoading(false)
      vueInstance.metalQuotation = response.data
      console.log(vueInstance.metalQuotation)
      vueInstance.referencePrice = ""
      vueInstance.priceList = []

      if (vueInstance.metalQuotation.referencePrices) {
        vueInstance.metalQuotation.referencePrices.forEach(price => {
          vueInstance.referencePrice = vueInstance.referencePrice + price.price + "/" + price.currency + "\n"
        })
      }
      
      vueInstance.priceList.push({
        key: "RM_COST",
        value: vueInstance.metalQuotation.rmCost
      })
      vueInstance.priceList.push({
        key: "PROCESSING_COST",
        value: vueInstance.metalQuotation.processingCost
      })
      vueInstance.priceList.push({
        key: "TREATMENT",
        value: vueInstance.metalQuotation.treatmentCost
      })
      vueInstance.priceList.push({
        key: "ACCESSORIES",
        value: vueInstance.metalQuotation.accessoriesCost
      })
      vueInstance.priceList.push({
        key: "OTHERS_PROCESS",
        value: vueInstance.metalQuotation.others
      })
      vueInstance.priceList.push({
        key: "RM_RATIO_NO_ACCESSORY",
        value: vueInstance.metalQuotation.rmRatio
      })
      vueInstance.priceList.push({
        key: "TOTAL_COST",
        value: vueInstance.metalQuotation.totalCost
      })
    })
}

Vue.prototype.$showPlasticCategoryAttribute = function(vueInstance, formNo) {
  vueInstance.plasticQuotation = {}
  vueInstance.toggleLoading(true)
  vueInstance.metalAttributeModel = false
  vueInstance.plasticAttributeModel = true
  vueInstance.pwbAttributeModel = false
  vueInstance.$quotationHttp
    .get("plastic/formNo/" + formNo)
    .then((response) => {
      vueInstance.toggleLoading(false)
      vueInstance.plasticQuotation = response.data
      vueInstance.referencePrice = ""
      vueInstance.priceList = []
      
      if (vueInstance.plasticQuotation.referencePrices) {
        vueInstance.plasticQuotation.referencePrices.forEach(price => {
          vueInstance.referencePrice = vueInstance.referencePrice + price.price + "/" + price.currency + "\n"
        })
      }
      vueInstance.priceList.push({
        key: "RM_COST",
        value: vueInstance.plasticQuotation.rmCost
      })
      vueInstance.priceList.push({
        key: "INJECTION_COST",
        value: vueInstance.plasticQuotation.injectionCost
      })
      vueInstance.priceList.push({
        key: "PROCESSING_COST",
        value: vueInstance.plasticQuotation.processingCost
      })
      vueInstance.priceList.push({
        key: "ACCESSORIES",
        value: vueInstance.plasticQuotation.accessoriesCost
      })
      vueInstance.priceList.push({
        key: "OTHERS_PROCESS",
        value: vueInstance.plasticQuotation.others
      })
      vueInstance.priceList.push({
        key: "RM_RATIO_NO_ACCESSORY",
        value: vueInstance.plasticQuotation.rmRatio
      })
      vueInstance.priceList.push({
        key: "TOTAL_COST",
        value: vueInstance.plasticQuotation.totalCost
      })
    })
}

Vue.prototype.$showPwbCategoryAttribute = function(vueInstance, formNo) {
  vueInstance.pwbQuotation = {}
  vueInstance.metalAttributeModel = false
  vueInstance.plasticAttributeModel = false
  vueInstance.pwbAttributeModel = true
  vueInstance.toggleLoading(true)
  vueInstance.$quotationHttp
    .get("supplier/pwb/formNo/" + formNo)
    .then((response) => {
      vueInstance.toggleLoading(false)
      vueInstance.pwbQuotation = response.data
      vueInstance.priceList = []
      vueInstance.priceList.push({
        key: "MATERIAL_COST",
        value: vueInstance.pwbQuotation.materialCost
      })
      vueInstance.priceList.push({
        key: "SURFACE_FINISH_COST",
        value: vueInstance.pwbQuotation.surfaceFinishCost
      })
      vueInstance.priceList.push({
        key: "PROCESSING_COST",
        value: vueInstance.pwbQuotation.processCost
      })
      vueInstance.priceList.push({
        key: "DELTA_PN_UP_PRICE_USD",
        value: vueInstance.pwbQuotation.deltaPnPriceUsd
      })
      vueInstance.priceList.push({
        key: "DELTA_PN_UP_PRICE",
        value: vueInstance.pwbQuotation.deltaPnPrice
      })
      vueInstance.priceList.push({
        key: "SPECIAL_COST_DOWN",
        value: vueInstance.pwbQuotation.specialCostDown
      })
    })
}

Vue.prototype.$validSupplierQuotationPrice = function(vueInstance, errorId, price, currency) {
  let errorMessage = ""

  if (!price) {
    errorMessage = errorMessage + errorId + vueInstance.$t('PLEASE_KEY_IN_PRICE') + " <br>"
  } else {
    if (!CheckFloat(price)) {
      errorMessage = errorMessage + errorId + vueInstance.$t('PRICE_MUST_BE_NUMBER') + " <br>"
    } else {
      if (Number(price) <= 0) {
        errorMessage = errorMessage + errorId + vueInstance.$t('PRICE_MUST_MORE_THAN_ZERO') + " <br>"
      }

      if (CheckCurrency(currency)) {
        if (price.toString().split("").reverse().join("").indexOf(".") > 4) {
          errorMessage = errorMessage + errorId + vueInstance.$t('PRICE_IS_MORE_THAN_FOUR_DIGITS') + " <br>"
        }
      } else {
        if (price.toString().split("").reverse().join("").indexOf(".") > 6) {
          errorMessage = errorMessage + errorId + vueInstance.$t('PRICE_IS_MORE_THAN_SIX_DIGITS') + " <br>"
        }
      }
    }
  }
  return errorMessage
}


Vue.prototype.$authHttp = authAxiosInstance
Vue.prototype.$quotationHttp = quotationAxiosInstance
Vue.prototype.$vendorHttp = vendorAxiosInstance
Vue.prototype.$fileHttp = fileAxiosInstance
Vue.prototype.$consignmentHttp = consignmentAxiosInstance
Vue.prototype.$Swal = Swal

Vuex.Store.prototype.$authHttp = authAxiosInstance
Vuex.Store.prototype.$quotationHttp = quotationAxiosInstance
Vuex.Store.prototype.$vendorHttp = vendorAxiosInstance
Vuex.Store.prototype.$fileHttp = fileAxiosInstance
Vuex.Store.prototype.$consignmentHttp = consignmentAxiosInstance
Vuex.Store.prototype.$Swal = Swal
Vuex.Store.prototype.$router = router
Vuex.Store.prototype.$i18n = i18n

Vue.use(vueDeltaIt, {locale})

Vue.config.productionTip = false

Vue.directive("upper-case", {
  inserted(el, _, vnode) {
    el.addEventListener("input", async e => {
      e.target.value = e.target.value.toUpperCase()
      vnode.componentInstance.$emit("input", e.target.value.toUpperCase())
    })
  },
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount("#app")
